import React from 'react';
import { clients } from '../data/content';
export function Clients() {
  return <section id="clients" aria-labelledby="clients-heading" className="scroll-mt-16 border-b border-hairline bg-slate-50 py-20 sm:py-24" data-id="element-15" data-mp="3jle1gaofi6zl">
      <div className="mx-auto max-w-content px-5 sm:px-8" data-id="element-16" data-mp="3eskxvq4p54p3">
        <div className="max-w-2xl" data-id="element-17" data-mp="39w47sqdxsg9d">
          <h2 id="clients-heading" className="text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-18" data-mp="39v2ltqvdu9cv">
            Who we work for
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ink-muted" data-id="element-19" data-mp="2zvlg59g4rvgw">
            Our client base is concentrated in three areas.
          </p>
        </div>

        <dl className="mt-12 grid gap-8 md:grid-cols-3 md:gap-10" data-id="element-20" data-mp="2qwqco54h0zha">
          {clients.map(client => <div key={client.title} className="border-t border-ink pt-5 md:border-t-2" data-id="element-21" data-mp="u4q3kqbcr8zy">
              <dt className="text-base font-semibold text-ink" data-id="element-22" data-mp="p6ersa1hyof3">
                {client.title}
              </dt>
              <dd className="mt-2 text-[15px] leading-relaxed text-ink-muted" data-id="element-23" data-mp="2npq01dhzl874">
                {client.description}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}